import React from 'react'
import Style from './AddRate.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsAltH } from '@fortawesome/free-solid-svg-icons';
const AddRate = (props) => {
        
    return (
        <section className={Style.CommentPart}>
                    <div className={Style.InputHolder}>
                        <input className={Style.Range} type="range" min='0' max="100" id='RankingRange' value={props.rate} onChange={e=>props.setRate(e.target.value)}/>
                        <div className={Style.Selector} id='selector' style={{left:`${props.rate}%`}}>
                            <div className={Style.selectBtn}><FontAwesomeIcon icon={faArrowsAltH} ng-disabled="isDisabled()"/></div>
                            <div className={Style.selectValue}>{props.rate}</div>
                        </div>
                        <div className={Style.ProgressBar} style={{width:`${props.rate}%`}}></div>
                    </div>
                    <div></div>
        </section>
    )
}

export default AddRate
